import { PayloadAction } from '@reduxjs/toolkit';
import { recaptchaSlice } from 'common/store/recaptchaSlice';
import { AppState, appStore } from 'common/store/store';
import React from 'react';
import {
    useGoogleReCaptcha
} from 'react-google-recaptcha-v3';
import { useSelector } from 'react-redux';
import { apiJson } from '../api';




export default () => {

    const { executeRecaptcha } = useGoogleReCaptcha();


    const canUploadFile = useSelector((state: AppState) => state.recaptcha.canUploadFile);
    const canUseContactForm = useSelector((state: AppState) => state.recaptcha.canUseContactForm);
    const timer = useSelector((state: AppState) => state.recaptcha.timer);
    const active = useSelector((state: AppState) => state.recaptcha.active);
    const [additionnalTime, setAdditionnalTime] = React.useState(0);

    // Create an event handler so you can call the verification on button click event or form submit
    const handleReCaptchaVerify = React.useCallback(async () => {

        if (!executeRecaptcha) {
            console.log('Execute recaptcha not yet available');
            return;
        }
        const currToken = await executeRecaptcha('submit');

        appStore.dispatch(recaptchaSlice.actions.updateToken(currToken ?? ''));

        const result: PayloadAction<any> = await apiJson('/recaptcha/verify', 'post', { token: currToken });
        appStore.dispatch(result);
        if (timer) window.clearTimeout(timer);

        setAdditionnalTime(curr => {
            let val = curr;
            if (!canUploadFile) return 0;
            if (canUploadFile) val += 20000;
            if (canUseContactForm) val += 10000;
            return val;
        });
        if (!canUploadFile) {
            const newTimer = window.setTimeout(handleReCaptchaVerify, (Math.round(Math.random() * 1000 * 50) + 10000) + additionnalTime); // revérification dans 10 à 60 secondes
            appStore.dispatch(recaptchaSlice.actions.setTimer(newTimer));
        }

    }, [executeRecaptcha]);



    // You can use useEffect to trigger the verification as soon as the component being loaded
    React.useEffect(() => {

        if (active) {
            handleReCaptchaVerify();
        } else {
            if (timer) {
                window.clearTimeout(timer);
                appStore.dispatch(recaptchaSlice.actions.setTimer(undefined));
            }
        }

    }, [handleReCaptchaVerify, active]);

    return <></>;
};
